// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3QmFY","right":"Footer_right__225sS","buttons":"Footer_buttons__13rJU"};